import apiClient from '../api/apiClient';

const BASE = '/api/v1/admin/price-list';

function unwrap(body) {
  if (body?.success === false) {
    const msg = body?.message;
    throw new Error(typeof msg === 'string' ? msg : 'Request failed');
  }
  return body?.data ?? body;
}

class PriceListService {
  async getLatest() {
    const response = await apiClient.get(`${BASE}/latest`);
    return unwrap(response.data);
  }

  async generate() {
    const response = await apiClient.post(`${BASE}/generate`);
    return response.data;
  }

  async getPublishStatus() {
    const response = await apiClient.get(`${BASE}/publish-status`);
    return unwrap(response.data);
  }

  async publish() {
    const response = await apiClient.post(`${BASE}/publish`);
    return response.data;
  }

  async listRuns(params = {}) {
    const response = await apiClient.get(`${BASE}/runs`, { params });
    return unwrap(response.data);
  }
}

export default new PriceListService();
